import VueGtag from 'vue-gtag';

export default function (app, env) {
    const gtag = env.VITE_GTAG;
	if (gtag) {
        app.use(VueGtag, {
            config: { id: gtag },
        });
    }
}